import { Flex, Separator } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { VideoLibrarySidebarEditor } from 'components/sections/video-library/sidebar/details-tab/editor';
import { VideoLibrarySidebarMiscDetails } from 'components/sections/video-library/sidebar/details-tab/misc';
import { VideoLibrarySidebarPreview } from 'components/sections/video-library/sidebar/details-tab/preview';

export const VideoLibrarySidebarDetailsTab = () => {
  return (
    <ErrorBoundary identifier="VideoLibrarySidebarDetailsTab">
      <Flex direction="column" gap="5">
        <VideoLibrarySidebarEditor />
        <Separator size="4" />
        <VideoLibrarySidebarMiscDetails />
        <Separator size="4" />
        <VideoLibrarySidebarPreview />
      </Flex>
    </ErrorBoundary>
  );
};
